<template>
  <footer></footer>
</template>

<script>
export default {
  name: "footer-view",
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
